import React from "react";
import "./Profile.css";
import {
  Avatar,
  Box,
  Paper,
  Stack,
  Typography,
  Badge,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  tableCellClasses,
  Table,
  InputAdornment,
  IconButton,
  Divider,
  AppBar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Helmet } from "react-helmet";
import { indigo, red, green, teal } from "@mui/material/colors";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { NavLink } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useDispatch } from "react-redux";
import { changePasswordData } from "../../redux/features/authSlice";

// Styled Box
const StyledBox = styled((props) => <Box {...props} />)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  border: `1px solid ${theme.palette.divider}`,
  padding: "0 16px",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "& .Box-content": {
    margin: "11.5px 8px",
    color: "initial",
    fontSize: "1.2rem",
  },
}));

// Styled Accordion
const Accordion = styled((props) => (
  <MuiAccordion disableGutters square elevation={0} {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon sx={{ fontSize: "1.5rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
  "& .AccordionSummary-head": {
    fontSize: "1.2rem",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
  "& .MuiButton-root": {
    textTransform: "initial",
  },
}));

function Profile() {
  const { userData } = useAuth();
  const dispatch = useDispatch();

  // Accordion
  const [expanded, setExpanded] = React.useState("");

  const handleAccordion = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  // handle textfield types
  const [textFieldtype, setTextFieldtype] = React.useState({
    oldpass: false,
    newpass: false,
    confirm_newpass: false,
  });

  const handleTextFieldType = (key) => {
    if (key === "oldpass")
      setTextFieldtype({ ...textFieldtype, oldpass: !textFieldtype.oldpass });
    else if (key === "newpass")
      setTextFieldtype({ ...textFieldtype, newpass: !textFieldtype.newpass });
    else
      setTextFieldtype({
        ...textFieldtype,
        confirm_newpass: !textFieldtype.confirm_newpass,
      });
  };

  // password change dialog variable
  const [openPasswordWindow, setOpenPasswordWindow] = React.useState(false);

  const handleWindowClose = () => {
    setOpenPasswordWindow(false);
    setPasswordData({
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    });
  };

  // Password data
  const [passwordData, setPasswordData] = React.useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });
  const handlePasswordData = (key) => (e) => {
    setPasswordData({ ...passwordData, [key]: e.target.value });
  };

  // Password handler
  const handleChangePassword = () => {
    // console.log(passwordData);
    dispatch(changePasswordData(passwordData));
    setOpenPasswordWindow(false);
  };

  return (
    <>
      <Helmet>
        <title>Alpha Targeting || Data-Camplinks</title>
      </Helmet>
      <Paper elevation={3}>
        <AppBar
          position="static"
          sx={{
            paddingBlock: "8px",
            paddingInline: "16px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack direction={"row"} spacing={2} alignItems={"center"} sx={{}}>
            <Avatar
              sx={{
                bgcolor: indigo[200],
                width: "40px",
                height: "40px",
              }}
            >
              <Typography variant="h6">
                {userData && userData.name && userData.name[0]}
              </Typography>
            </Avatar>

            <Box>
              <Typography variant="strong" component="h6">
                {userData && userData.name}
              </Typography>
              <Typography variant="body2" component="h6">
                {userData && userData.email}
              </Typography>
            </Box>
          </Stack>

          <Typography variant="h6" component="span" textTransform="capitalize">
            {userData && userData.role}
          </Typography>
        </AppBar>

        {userData &&
        (userData.role === "admin" || userData.role === "super_admin") ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              borderRadius: "8px",
              // border: "2px solid red",
            }}
            // className=" d-flex align-items-center rounded "
          >
            <Stack direction="column" p={4} sx={{ width: "400px" }}>
              <Typography
                p={2}
                className="text-center"
                variant="h6"
                sx={{
                  textTransform: "uppercase",
                  bgcolor: "#1976d2",
                  color: "white",
                  borderRadius: "15px 15px 0 0",
                }}
              >
                <b>Operations</b>
              </Typography>
              {/* <Accordion
              expanded={expanded === "panel1"}
              onChange={handleAccordion("panel1")}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography className="AccordionSummary-head">
                  Additional Roles
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="space-around"
                >
                  <NavLink to="/operation/additional-roles">
                    <Button
                      color="info"
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: indigo[400] }}
                    >
                      <b>View Roles</b>
                    </Button>
                  </NavLink>
                  <NavLink to="/operation/user-roles">
                    <Button
                      color="info"
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: teal[400] }}
                    >
                      <b>User Roles</b>
                    </Button>
                  </NavLink>
                </Stack>
              </AccordionDetails>
            </Accordion> */}
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleAccordion("panel2")}
              >
                <AccordionSummary
                  aria-controls="panel2d-content"
                  id="panel2d-header"
                >
                  <Typography className="AccordionSummary-head">
                    Modules
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack
                    direction="row"
                    spacing={1}
                    justifyContent="space-around"
                  >
                    {/* <NavLink to="/operation/modules">
                    <Button
                      color="info"
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: indigo[400] }}
                    >
                      <b>View Modules</b>
                    </Button>
                  </NavLink> */}
                    <NavLink to="/admin/role-modules">
                      <Button
                        color="info"
                        variant="contained"
                        size="large"
                        sx={{ backgroundColor: teal[400] }}
                      >
                        <b>Role Modules</b>
                      </Button>
                    </NavLink>
                  </Stack>
                </AccordionDetails>
              </Accordion>
              <StyledBox>
                <NavLink to="/admin/all-users">
                  <Typography className="Box-content">Users</Typography>
                </NavLink>
              </StyledBox>
              {/* <StyledBox sx={{ borderRadius: "0 0 15px 15px" }}>
              <NavLink to="/admin/approve">
                <Typography className="Box-content">Approvals</Typography>
              </NavLink>
            </StyledBox> */}
            </Stack>
          </Box>
        ) : null}
      </Paper>
    </>
  );
}

export default Profile;
